import { Component, OnInit } from '@angular/core';
import { PortalError } from '@app/utils/error/portal-error';
import { CallCenterQueueContext } from '@business/call-center/models/call-center-queue-context';
import { CallCenterService } from '@business/call-center/services/call-center-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'portal-call-center-queue-sub-nav',
  templateUrl: './call-center-queue-sub-nav.component.html',
  styles: [],
  standalone: false,
})
export class CallCenterQueueSubNavComponent implements OnInit {
  error$!: Observable<PortalError | null>;
  loading$!: Observable<boolean>;
  viewModel$!: Observable<CallCenterQueueContext>;

  constructor(private callCenterService: CallCenterService) {}

  ngOnInit() {
    this.error$ = this.callCenterService.queueContext.error$.pipe(untilDestroyed(this));
    this.loading$ = this.callCenterService.queueContext.loading$.pipe(untilDestroyed(this));
    this.viewModel$ = this.callCenterService.queueContext.data$.pipe(untilDestroyed(this));
  }
}
